export const slotConstants = {
    GETSLOTS_RESET: 'USERS_GETSLOTS_RESET',
    GETSLOTS_REQUEST: 'USERS_GETSLOTS_REQUEST',
    GETSLOTS_SUCCESS: 'USERS_GETSLOTS_SUCCESS',
    GETSLOTS_FAILURE: 'USERS_GETSLOTS_FAILURE',
    GET_SELECTED_SLOTS_SUCCESS:'GET_SELECTED_SLOTS_SUCCESS',

    GET_COUNSELLOR_LIST_REQUEST: 'GET_COUNSELLOR_LIST_REQUEST',
    GET_COUNSELLOR_LIST_SUCCESS: 'GET_COUNSELLOR_LIST_SUCCESS',
    GET_COUNSELLOR_LIST_FAILURE: 'GET_COUNSELLOR_LIST_FAILURE',

    GET_PUBLIC_COUNSELLOR_LIST_REQUEST: 'GET_PUBLIC_COUNSELLOR_LIST_REQUEST',
    GET_PUBLIC_COUNSELLOR_LIST_SUCCESS: 'GET_PUBLIC_COUNSELLOR_LIST_SUCCESS',
    GET_PUBLIC_COUNSELLOR_LIST_FAILURE: 'GET_PUBLIC_COUNSELLOR_LIST_FAILURE',

    GET_MY_COUNSELLOR_REQUEST: 'GET_MY_COUNSELLOR_REQUEST',
    GET_MY_COUNSELLOR_SUCCESS: 'GET_MY_COUNSELLOR_SUCCESS',
    GET_MY_COUNSELLOR_FAILURE: 'GET_MY_COUNSELLOR_FAILURE',

    DELETE_SLOT_REQUEST: 'DELETE_SLOT_REQUEST',
    DELETE_SLOT_SUCCESS: 'DELETE_SLOT_SUCCESS', 
    DELETE_SLOT_FAILURE: 'DELETE_SLOT_FAILURE'
}


// WEBPACK FOOTER //
// ./src/store/constants/slot.constants.js